module.exports = __webpack_public_path__ + "static/mobile-53f4b8391bd9d08a6ab6b22d4eebb1f1.jpg";